import Index from '@/views/activities/Index.vue'

export default [
  {
    path: ':clientId/activities',
    name: 'activities.index',
    component: Index
  }
]
